// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2PiMV","button":"style_button__3jZyo"};